import { FormLayout } from "@careinfo/layout";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormProvider, useForm, UseFormSetError } from "react-hook-form";
import { IComponent } from "../../types/interface";
import { componentValidation } from "../../utils/validationSchema";
import ComponentForm from "./Form";

interface Props {
  handleCreate: (
    data: IComponent,
    setError: UseFormSetError<IComponent>
  ) => Promise<void>;
  isCreatingNavigation: boolean;
}

export default function CreateComponent({
  isCreatingNavigation,
  handleCreate,
}: Props) {
  const createComponentMethods = useForm<IComponent>({
    resolver: yupResolver(componentValidation),
  });

  return (
    <>
      <FormLayout
        isLoading={isCreatingNavigation}
        handleSubmit={createComponentMethods.handleSubmit}
        handleFormSubmit={handleCreate}
        buttonLabel="Create"
        disabled={isCreatingNavigation}
        setError={createComponentMethods.setError}
      >
        <FormProvider {...createComponentMethods}>
          <ComponentForm />
        </FormProvider>
      </FormLayout>
    </>
  );
}
